module.exports = __webpack_public_path__ + "bdd55042.svg";